import React from "react";
import { Box } from "@mui/material";
import "./Style.scss";

import PropTypes from "prop-types";
import EachMethod2FA from "./EachMethod2FA";

function Register2FAChooseType({
  setOpenReEnterPassword,
  setOpen2FAChooseType,
  setOpenCheckOTPFirst,
  setType,
}) {
  return (
    <Box width={460} className="form-container">
      <p className="fs-20 fw-700">Xác Thực 2 Bước</p>
      <p className="fs-14">
        Sau khi nhập mật khẩu, hệ thống yêu cầu thực hiện xác minh bước thứ hai
      </p>
      <EachMethod2FA
        methodData={{
          methodTitle: "Xác thực bằng SMS",
          methodContent: "Sử dụng mã trong tin nhắn để xác thực tài khoản",
        }}
        setOpenCheckOTPFirst={setOpenCheckOTPFirst}
        setOpen2FAChooseType={setOpen2FAChooseType}
        setType={setType}
      />
      <EachMethod2FA
        methodData={{
          methodTitle: "Xác thực bằng Email",
          methodContent: "Sử dụng mã trong email để xác thực tài khoản",
        }}
        setOpenCheckOTPFirst={setOpenCheckOTPFirst}
        setOpen2FAChooseType={setOpen2FAChooseType}
        setType={setType}
      />
      <EachMethod2FA
        methodData={{
          methodTitle: "Xác thực bằng Google Authenticator",
          methodContent:
            "Sử dụng ứng dụng Authenticator để nhận mã xác thực miễn phí ngay khi điện thoại đang ngoại tuyến",
        }}
        setOpenCheckOTPFirst={setOpenCheckOTPFirst}
        setOpen2FAChooseType={setOpen2FAChooseType}
        setType={setType}
      />
      <EachMethod2FA
        methodData={{
          methodTitle: "Xác thực bằng Microsoft Authenticator",
          methodContent:
            "Sử dụng ứng dụng Authenticator để nhận mã xác thực miễn phí ngay khi điện thoại đang ngoại tuyến",
        }}
        setOpenCheckOTPFirst={setOpenCheckOTPFirst}
        setOpen2FAChooseType={setOpen2FAChooseType}
        setType={setType}
      />
      <EachMethod2FA
        methodData={{
          methodTitle: "Xác thực bằng Mẫu hình",
          methodContent: "Sử dụng mẫu hình để xác thực tài khoản",
        }}
        setOpenCheckOTPFirst={setOpenCheckOTPFirst}
        setOpen2FAChooseType={setOpen2FAChooseType}
        setType={setType}
      />
      {/* <EachMethod2FA
        methodData={{
          methodTitle: "Xác thực bằng Vân tay",
          methodContent: "Sử dụng vân tay để xác thực tài khoản",
        }}
        setOpenCheckOTPFirst={setOpenCheckOTPFirst}
        setOpen2FAChooseType={setOpen2FAChooseType}
        setType={setType}
      />
      <EachMethod2FA
        methodData={{
          methodTitle: "Xác thực bằng Khuôn mặt",
          methodContent: "Sử dụng khuôn mặt để xác thực tài khoản",
        }}
        setOpenCheckOTPFirst={setOpenCheckOTPFirst}
        setOpen2FAChooseType={setOpen2FAChooseType}
        setType={setType}
      />
      <EachMethod2FA
        methodData={{
          methodTitle: "Xác thực bằng Võng mạc",
          methodContent: "Sử dụng võng mạc để xác thực tài khoản",
        }}
        setOpenCheckOTPFirst={setOpenCheckOTPFirst}
        setOpen2FAChooseType={setOpen2FAChooseType}
        setType={setType}
      />
      <EachMethod2FA
        methodData={{
          methodTitle: "Xác thực bằng Giọng nói",
          methodContent: "Sử dụng giọng nói để xác thực tài khoản",
        }}
        setOpenCheckOTPFirst={setOpenCheckOTPFirst}
        setOpen2FAChooseType={setOpen2FAChooseType}
        setType={setType}
      /> */}
      <Box
        className="d-flex centered fs-14"
        style={{
          width: "40%",
          height: "36px",
          borderRadius: "6px",
          color: "var(--blue-blue-100)",
          border: "2px solid var(--blue-blue-100)",
          cursor: "pointer",
        }}
        role="button"
        tabIndex="0"
        onClick={() => {
          setOpenReEnterPassword((prev) => !prev);
          setOpen2FAChooseType((prev) => !prev);
        }}
        onKeyDown={() => {}}
      >
        Quay lại
      </Box>
    </Box>
  );
}

Register2FAChooseType.defaultProps = {
  setOpenReEnterPassword: () => {},
  setOpen2FAChooseType: () => {},
  setOpenCheckOTPFirst: () => {},
  setType: () => {},
};

Register2FAChooseType.propTypes = {
  setOpenReEnterPassword: PropTypes.func,
  setOpen2FAChooseType: PropTypes.func,
  setOpenCheckOTPFirst: PropTypes.func,
  setType: PropTypes.func,
};

export default Register2FAChooseType;
